import React, { Fragment } from 'react';
import styled from 'styled-components';
import Loader from '4all-ui/components/Loader';
import Button from '4all-ui/components/Button';
import PropTypes from 'prop-types';
import { flexPosition, fontStyle } from '../../styles/mixins';
import { customModalStyles } from '../../helpers/constants';
import Modal from 'react-modal/lib/components/Modal';
import ConfirmIcon from '../Icons/Confirm';
import AlertIcon from '../../images/icon-alert.svg';
import { GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD, GRAY_LIGHTER } from '../../styles/variables';
import { getParentSelector } from '../../helpers/modal';

const Content = styled.div`
  padding: 20px;
  margin: 0 auto;
  ${flexPosition({ align: 'center', justify: 'space-around' })}
  flex-direction: column;
  height: 100%;
`;

const CustomText = styled.p`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  width: ${({ error }) => (error ? '165px' : '140px')};
  text-align: center;
`;

const ErrorIcon = styled.span`
  width: 70px;
  height: 70px;
  margin-top: 25px;
  margin-bottom: 25px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${AlertIcon});
`;

const closeButton = onClose => {
  return (
    <Button
      id="form-loader-close-button"
      onClick={onClose}
      width="110px"
      height="45px"
      customStyles={{
        marginTop: '30px',
        padding: '10px',
        color: GRAY_DARKER,
        backgroundColor: 'transparent',
        border: `1px solid ${GRAY_LIGHTER}`,
        ':hover': {
          backgroundColor: 'transparent',
        },
      }}
      noHover
    >
      Fechar
    </Button>
  );
};

const FormLoader = ({ showModal, onClose, isSubmiting, loadingText, finishedText, error }) => (
  <Fragment>
    <Modal
      ariaHideApp={false}
      isOpen={showModal}
      style={{
        content: {
          ...customModalStyles.content,
          width: '260px',
          height: isSubmiting ? '260px' : 'auto',
        },
        overlay: customModalStyles.overlay,
      }}
      parentSelector={getParentSelector}
    >
      {isSubmiting ? (
        <Content id="form-loader-modal" className="form-loader-modal__loading">
          <Loader size="100px" width="8px" />
          <CustomText>{loadingText}</CustomText>
        </Content>
      ) : error.message ? (
        <Content id="form-loader-modal" className="form-loader-modal__error">
          <ErrorIcon />
          <CustomText id="form-loader-custom-text" error={!!error.message}>
            {error.message}
          </CustomText>
          {closeButton(onClose)}
        </Content>
      ) : (
        <Content id="form-loader-modal" className="form-loader-modal__finished">
          <ConfirmIcon size="120px" />
          <CustomText id="form-loader-custom-text">{finishedText}</CustomText>
          {closeButton(onClose)}
        </Content>
      )}
    </Modal>
  </Fragment>
);

FormLoader.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  isSubmiting: PropTypes.bool,
  loadingText: PropTypes.string,
  finishedText: PropTypes.string,
  error: PropTypes.object,
};

FormLoader.defaultProps = {
  showModal: false,
  isSubmiting: true,
  loadingText: 'Salvando ...',
  finishedText: 'Cadastro realizado com sucesso!',
  error: {},
};

export default FormLoader;



// WEBPACK FOOTER //
// ./src/components/FormLoader/index.js